import React, { useState, useRef } from 'react';
import BareVolume from 'assets/images/bare-volume.png';
import Indicator from "assets/images/bare-volume-indicator.png";
import './index.scss';

const VolumeKnob = ({ step, setValue, active, hasRotation, hasClick, handleClick }) => {
  const [startDegrees, setStartDegrees] = useState(null);
  const [knobAngleStart, setKnobAngleStart] = useState(null);
  const [knobAngle, setKnobAngle] = useState(0);
  const [rotate, setRotate] = useState(false);
  const volumeButtonKnobRef = useRef(null);

  const ROTATION_STEP = 360 / step;


  const handleKnobPosition = (angle) => {
    let newAngle = angle - knobAngleStart;

    if (newAngle > 50) {
      newAngle -= 360;
    } else if (newAngle < -50) {
      newAngle += 360;
    }

    setKnobAngle((preValue) => {
      return preValue + newAngle;
    });
    setKnobAngleStart(angle)
  };

  const getAngle = (x, y) => {
    const rect = volumeButtonKnobRef.current?.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    const dx = x - centerX;
    const dy = y - centerY;

    let angle = -Math.atan2(dy, dx) * (180 / Math.PI);
    if (angle < 0) {
      angle += 360
    }
    return angle
  };
  const onClick = ()=> {
    if (!hasClick) return
    handleClick();
  }

  const setByCoords = (x, y) => {
    if (!rotate || !hasRotation) return;

    const angle = getAngle(x, y);
    handleKnobPosition(angle);

    const deltaDegrees = angle - startDegrees;

    if ((deltaDegrees < - ROTATION_STEP && deltaDegrees > ROTATION_STEP - 360) || deltaDegrees > 360 - ROTATION_STEP) {
      setValue(1);
      setStartDegrees(angle);
    } else if (deltaDegrees > ROTATION_STEP || deltaDegrees < ROTATION_STEP - 360) {
      setValue(-1);
      setStartDegrees(angle);
    }
  };

  const handleStart = (e) => {
    setRotate(true);
    const angle = getAngle(e.clientX, e.clientY);
    setStartDegrees(angle);
    setKnobAngleStart(angle);
  }

  const handleMouseDown = (e) => {
    // e.preventDefault();
    handleStart(e);
  };

  const handleTouchStart = (e) => {
    // e.preventDefault();
    const touch = e.touches[0];
    handleStart(touch);
  };

  const handleMouseMove = (e) => {
    setByCoords(e.clientX, e.clientY);
  };

  const handleTouchMove = (e) => {
    const touch = e.touches[0];
    setByCoords(touch.clientX, touch.clientY);
  };

  const handleEnd = () => {
    setStartDegrees(null);
    setKnobAngleStart(null);
    setRotate(false);
  };

  return (
    <div
      className="volume-button-knob"
      ref={volumeButtonKnobRef}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      onMouseMove={handleMouseMove}
      onTouchMove={handleTouchMove}
      onMouseUp={handleEnd}
      onTouchEnd={handleEnd}
      onClick={onClick}
      style={{touchAction: 'none'}}
    >
      <div className="knob-wrapper">
        <img
          src={BareVolume}
          alt="Bare Volume Button"
          className={`knob ${active ? 'active' : ''}`}
        />
        <img
          src={Indicator}
          alt="Indicator"
          className="indicator"
          style={{ transform: `rotate(${-knobAngle}deg) translate(0, 320%)` }}
        />
      </div>
    </div>
  );
};

export default VolumeKnob;
